import { arrayToObject } from '@hotglue/common';

const defaultState = {
  supportedFlows: undefined,
  linkedFlows: undefined,
  linkedFlowsStatus: undefined,
  selectedFlow: undefined,
  processingOAuth: false,
};

export default (state = defaultState, action) => {
  let newState = Object.assign({}, state);
  const { payload, status, type, params } = action;

  switch (type) {
    case 'SET_TENANT':
      newState.linkedFlows = undefined;
      newState.linkedFlowsStatus = undefined;
      return newState;
    case 'FETCH_SUPPORTED_FLOW':
      if (status === 'success') {
        const { flow } = params
        if (newState.supportedFlows) {
          newState.supportedFlows[flow] = payload
        } else {
          newState.supportedFlows = { [flow]: payload }
        }

      }
      return newState
    case 'FETCH_SUPPORTED_FLOWS':
      if (status == 'success') newState.supportedFlows = arrayToObject(payload);
      return newState;

    case 'FETCH_LINKED_FLOWS':
      if (status == 'success') newState.linkedFlows = arrayToObject(payload);
      newState.linkedFlowsStatus = status;
      return newState;

    case 'SELECT_FLOW':
      newState.selectedFlow = payload;
      return newState;

    case 'START_LINKING_SOURCE':
      newState.processingOAuth = true;
      return newState;

    case 'STOP_LINKING_SOURCE':
      newState.processingOAuth = false;
      return newState;
  }

  return state;
};
